import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { colors } from '../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import BidAskBox from '../../../../charts/d3/candlestickchart/newCandleChart/chartHeader/BidAskBox';
import NotInPositionButtonArray from '../notInPositionButtonArray/NotInPositionButtonArray';
import PnLDisplay from '../pnLDisplay/PnLDisplay';
import {
  definingSetupDetails,
  definingTradeDirection,
  determineStatus,
} from '../tradePlanIdentityDisplay/identityDisplayUtils';
import style from './NotInPositionTopRow.module.css';
import { TopRowBox } from './topRowBox/TopRowBox';
import { TopRowFillPrice } from './topRowBox/TopRowFillPrice';
import { TopRowExpandButton } from './topRowExpandButton/TopRowExpandButton';
const directionColorMap = {
  SHORT: colors.red,
  LONG: colors.green,
  BOTH: colors.blue,
};
const statusColorMap = {
  ARMED: colors.blue,
  ENTERED: colors.green,
  PAUSED: colors.orange,
  DEACTIVATED: colors.lightGrey,
};
export const NotInPositionTopRow = observer(({ tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const direction = definingTradeDirection(tradePlan);
  const status = determineStatus(tradePlan);

  
  return (
    <div className={style.container}>
      <div className={style.topRow}>
        <TopRowBox
          backgroundColor={colors.grey}
          color={colors.lightGrey}
          width="100px"
        >
          {tradePlan.symbol}
        </TopRowBox>
        <TopRowBox
          backgroundColor={colors.grey}
          color={directionColorMap[direction]}
          width="100px"
        >
          {direction}
        </TopRowBox>
        <TopRowBox
          backgroundColor={colors.grey}
          color={statusColorMap[status]}
          width="100px"
        >
          {status}
        </TopRowBox>
        {tradePlan.savedConfigurationTitle ? (
          <TopRowBox
            backgroundColor={colors.grey}
            color={colors.lightGrey}
            width="205px"
            justifyContent={
              tradePlan.savedConfigurationTitle.length > 20
                ? 'flexStart'
                : 'center'
            }
          >
            {tradePlan.savedConfigurationTitle}
          </TopRowBox>
        ) : (
          <TopRowBox
            backgroundColor={colors.grey}
            color={colors.lightGrey}
            width="205px"
          >
            {definingSetupDetails(tradePlan)}
          </TopRowBox>
        )}
      </div>
      <div className={style.thirdRow}>
        <TopRowFillPrice positionId={tradePlan.positionId} />

        <PnLDisplay tradePlanId={tradePlanId} />
        <BidAskBox
          symbol={tradePlan.symbol}
          dataSource={tradePlan.dataSource}
        />
      </div>
      <div className={style.thirdRow}>
        <NotInPositionButtonArray tradePlanId={tradePlanId} />
      </div>
      <div className={style.bottomRow}>
        <TopRowExpandButton
          height="24px"
          width="520px"
          backgroundColor={colors.grey}
          fill={colors.lightGrey}
          clickHandler={() => tradePlanStore.flipExpandedState(tradePlanId)}
          expanded={tradePlan.expanded}
        />
      </div>
    </div>
  );
});

NotInPositionTopRow.propTypes = {
  expanded: PropTypes.bool,
  setExpanded: PropTypes.func,
  tradePlanId: PropTypes.string,
};
